import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Table, Input, DatePicker, Checkbox } from 'antd';
import moment from 'moment';
// import UilEdit from '@iconscout/react-unicons/icons/uil-edit';
// import { Link } from 'react-router-dom';
import { UilSearch, UilLocationPoint } from '@iconscout/react-unicons';

import { PageHeader } from '../../components/page-headers/page-headers';
// import { AutoComplete } from '../../components/autoComplete/autoComplete';
import { Button } from '../../components/buttons/buttons';
import { Cards } from '../../components/cards/frame/cards-frame';

import { Main, CardToolbox, TableWrapper } from '../styled';
import { UserTableStyleWrapper } from '../pages/style';
import { getDiagnosticData, exportToExcelData } from '../../redux/diagnostic/actionCreator';

const tableColumns = [
  {
    title: 'Time',
    dataIndex: 'timestamp',
    key: 'timestamp',
  },
  {
    title: 'Machine ID',
    dataIndex: 'machineid',
    key: 'machineid',
  },
  {
    title: 'SD Card',
    dataIndex: 'sdcard',
    key: 'sdcard',
    align: 'center',
  },
  {
    title: 'RTC',
    dataIndex: 'rtc',
    key: 'rtc',
    align: 'center',
  },
  {
    title: 'WiFi Config',
    dataIndex: 'wificonfig',
    key: 'wificonfig',
    align: 'center',
  },
  {
    title: 'WiFi Connection',
    dataIndex: 'wificonnection',
    key: 'wificonnection',
    align: 'center',
  },
  {
    title: 'WiFi Strength',
    dataIndex: 'wifistrength',
    key: 'wifistrength',
    align: 'center',
  },
  {
    title: 'Temperature',
    dataIndex: 'temperature',
    key: 'temperature',
  },
  {
    title: 'Core',
    dataIndex: 'core',
    key: 'core',
    align: 'left',
  },
  {
    title: 'IP / MAC',
    dataIndex: 'address',
    key: 'address',
    align: 'left',
  },
  // {
  //   title: 'Actions',
  //   dataIndex: 'action',
  //   key: 'action',
  //   width: '90px',
  // },
];

function DiagnosticData() {
  const dispatch = useDispatch();

  const { searchData, diagnosticData, loading } = useSelector((state) => {
    return {
      searchData: state.headerSearchData,
      diagnosticData: state.diagnostic.data,
      loading: state.diagnostic.loading,
    };
  });

  const [hasFetched, setHasFetched] = useState(false);
  const [state, setState] = useState({
    notData: searchData,
    selectedRowKeys: 0,
    selectedRows: 0,
    machineId: '',
    selectedDate: '',
    isSearch: false,
    checked: false,
    isExport: false,
  });

  // const { notData } = state;

  useEffect(() => {
    if (!hasFetched) {
      dispatch(getDiagnosticData(''));
      setHasFetched(true);
    }

    return () => {
      // Any cleanup code you want to execute when the component unmounts or the effect changes
    };
  }, [hasFetched, dispatch, !state.isSearch]);

  const tableData = [];
  if (!loading && diagnosticData?.length !== 0) {
    diagnosticData?.map((machine, i) => {
      const {
        timestamp,
        machineid,
        sdcard,
        rtc,
        wificonfig,
        wificonnection,
        wifistrength,
        temperature,
        core,
        macid,
        ipaddr,
      } = machine;

      return tableData.push({
        key: i,
        timestamp: <div>{moment(timestamp).format('hh:mm a')}</div>,
        machineid,
        sdcard: (
          <div>
            {sdcard === 1 ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30">
                <path
                  id="check-circle"
                  d="M21.08,12.185l-6.435,6.45L12.17,16.16a1.5,1.5,0,1,0-2.115,2.115l3.525,3.54a1.5,1.5,0,0,0,2.115,0l7.5-7.5a1.5,1.5,0,1,0-2.115-2.13ZM17,2A15,15,0,1,0,32,17,15,15,0,0,0,17,2Zm0,27A12,12,0,1,1,29,17,12,12,0,0,1,17,29Z"
                  transform="translate(-2 -2)"
                  fill="#01b81a"
                />
              </svg>
            ) : (
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                  fill="#F00"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                  fill="#F00"
                />
              </svg>
            )}
          </div>
        ),
        rtc: (
          <div>
            {rtc === 1 ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30">
                <path
                  id="check-circle"
                  d="M21.08,12.185l-6.435,6.45L12.17,16.16a1.5,1.5,0,1,0-2.115,2.115l3.525,3.54a1.5,1.5,0,0,0,2.115,0l7.5-7.5a1.5,1.5,0,1,0-2.115-2.13ZM17,2A15,15,0,1,0,32,17,15,15,0,0,0,17,2Zm0,27A12,12,0,1,1,29,17,12,12,0,0,1,17,29Z"
                  transform="translate(-2 -2)"
                  fill="#01b81a"
                />
              </svg>
            ) : (
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                  fill="#F00"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                  fill="#F00"
                />
              </svg>
            )}
          </div>
        ),
        wificonfig: (
          <div>
            {wificonfig === 1 ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30">
                <path
                  id="check-circle"
                  d="M21.08,12.185l-6.435,6.45L12.17,16.16a1.5,1.5,0,1,0-2.115,2.115l3.525,3.54a1.5,1.5,0,0,0,2.115,0l7.5-7.5a1.5,1.5,0,1,0-2.115-2.13ZM17,2A15,15,0,1,0,32,17,15,15,0,0,0,17,2Zm0,27A12,12,0,1,1,29,17,12,12,0,0,1,17,29Z"
                  transform="translate(-2 -2)"
                  fill="#01b81a"
                />
              </svg>
            ) : (
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                  fill="#F00"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                  fill="#F00"
                />
              </svg>
            )}
          </div>
        ),
        wificonnection: (
          <div>
            {wificonnection === 1 ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30">
                <path
                  id="check-circle"
                  d="M21.08,12.185l-6.435,6.45L12.17,16.16a1.5,1.5,0,1,0-2.115,2.115l3.525,3.54a1.5,1.5,0,0,0,2.115,0l7.5-7.5a1.5,1.5,0,1,0-2.115-2.13ZM17,2A15,15,0,1,0,32,17,15,15,0,0,0,17,2Zm0,27A12,12,0,1,1,29,17,12,12,0,0,1,17,29Z"
                  transform="translate(-2 -2)"
                  fill="#01b81a"
                />
              </svg>
            ) : (
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                  fill="#F00"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                  fill="#F00"
                />
              </svg>
            )}
          </div>
        ),
        wifistrength,
        temperature: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {temperature}{' '}
            <svg
              fill="#000000"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              id="celsius"
              data-name="Line Color"
              xmlns="http://www.w3.org/2000/svg"
              className="icon line-color"
            >
              <circle
                id="secondary"
                cx="5"
                cy="6"
                r="2"
                style={{
                  fill: 'none',
                  stroke: 'rgb(44, 169, 188)',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeWidth: 2,
                }}
              />
              <path
                id="primary"
                d="M21,7.55A6.55,6.55,0,0,0,16.77,6,6.89,6.89,0,0,0,10,13a6.89,6.89,0,0,0,6.77,7A6.55,6.55,0,0,0,21,18.45"
                style={{
                  fill: 'none',
                  stroke: 'rgb(0, 0, 0)',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeWidth: 2,
                }}
              />
            </svg>
          </div>
        ),
        core: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {core}{' '}
            <svg
              fill="#000000"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              id="celsius"
              data-name="Line Color"
              xmlns="http://www.w3.org/2000/svg"
              className="icon line-color"
            >
              <circle
                id="secondary"
                cx="5"
                cy="6"
                r="2"
                style={{
                  fill: 'none',
                  stroke: 'rgb(44, 169, 188)',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeWidth: 2,
                }}
              />
              <path
                id="primary"
                d="M21,7.55A6.55,6.55,0,0,0,16.77,6,6.89,6.89,0,0,0,10,13a6.89,6.89,0,0,0,6.77,7A6.55,6.55,0,0,0,21,18.45"
                style={{
                  fill: 'none',
                  stroke: 'rgb(0, 0, 0)',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeWidth: 2,
                }}
              />
            </svg>
          </div>
        ),
        address: (
          <div>
            {ipaddr || '-'} / {macid || '-'}{' '}
          </div>
        ),
        // action: (
        //   <div className="table-actions">
        //     <Button className="btn-icon" type="info" to="#" shape="circle">
        //       <UilEdit />
        //     </Button>
        //   </div>
        // ),
      });
    });
  }

  const handleChange = useCallback(({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
      isSearch: false,
      checked: false,
      isExport: false,
    });
  }, []);

  const handleDateChange = (date, dateString) => {
    // const isCheck = state.machineId !== '' ? true : false;
    setState({
      ...state,
      selectedDate: dateString,
      isSearch: false,
      checked: false,
      isExport: true,
    });
  };

  const onChange = ({ target }) => {
    setState({ ...state, isSearch: false, checked: target.checked });
  };

  const searchHandler = useCallback(() => {
    // if the search element is empty machine id and selected date return false
    if (state.machineId === '' && state.selectedDate === '') return;

    // Create a URLSearchParams object
    const urlParams = new URLSearchParams();
    // Add parameters to the URLSearchParams object
    if (state.machineId !== '') urlParams.append('machineId', state.machineId);
    if (state.selectedDate !== '') urlParams.append('date', state.selectedDate);
    urlParams.append('all', state.checked ? 'true' : 'false');

    // Combine the URL with the query parameters
    const query = `?${urlParams.toString()}`;

    setState({ ...state, isSearch: true });
    dispatch(getDiagnosticData(query));
  }, [state]);

  const clearSearchHandler = () => {
    setState({ ...state, isSearch: false, machineId: '', selectedDate: '', checked: false });

    dispatch(getDiagnosticData(''));
  };

  const exportToExcelHandler = useCallback(() => {
    // if (!state.isSearch) {
    // }
    // Create a URLSearchParams object
    const urlParams = new URLSearchParams();
    // Add parameters to the URLSearchParams object
    if (state.machineId !== '') urlParams.append('machineId', state.machineId);
    if (state.selectedDate !== '') urlParams.append('date', state.selectedDate);
    urlParams.append('all', state.checked ? 'true' : 'false');

    // Combine the URL with the query parameters
    const query = `?${urlParams.toString()}`;

    setState({ ...state });
    dispatch(exportToExcelData(query));
  }, [state]);

  return (
    <>
      <CardToolbox>
        <PageHeader
          className="ninjadash-page-header-main"
          ghost
          title="Diagnostic Data"
          subTitle={
            <>
              <span className="title-counter">{diagnosticData?.length} Data</span>
              {/* <AutoComplete
                onSearch={handleSearch}
                dataSource={notData}
                placeholder="Search by Name"
                width="100%"
                patterns
              /> */}
            </>
          }
          buttons={[
            <div className="input-search-container align-center-v">
              <Input
                size="medium"
                prefix={<UilSearch />}
                className="search-input"
                id="title"
                placeholder="Machine Id"
                name="machineId"
                onChange={handleChange}
                value={state.machineId}
              />
              <DatePicker
                id="location"
                size="madium"
                className="search-datepicker"
                prefix={<UilLocationPoint />}
                placeholder="Date "
                onChange={handleDateChange}
                value={state.selectedDate !== '' ? moment(state.selectedDate) : ''}
              />

              <Checkbox onChange={onChange} checked={state.checked}>
                All
              </Checkbox>

              {!state.isSearch ? (
                <Button onClick={searchHandler} size="madium" type="primary">
                  <UilSearch /> Search
                </Button>
              ) : (
                <Button onClick={clearSearchHandler} size="madium" type="default">
                  <UilSearch /> Clear
                </Button>
              )}
            </div>,
            <Button onClick={exportToExcelHandler} size="medium" type="default">
              Export
            </Button>,
          ]}
        />
      </CardToolbox>

      <Main>
        <Row gutter={15}>
          <Col md={24}>
            <Cards headless>
              <UserTableStyleWrapper>
                <TableWrapper className="table-responsive">
                  <Table
                    dataSource={tableData}
                    columns={tableColumns}
                    size="small"
                    loading={loading}
                    pagination={{
                      defaultPageSize: 100,
                      total: diagnosticData?.length,
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                  />
                </TableWrapper>
              </UserTableStyleWrapper>
            </Cards>
          </Col>
        </Row>
      </Main>
    </>
  );
}

export default DiagnosticData;
